import { GeoAuthorization, GeoTracking } from '@dispatch/shared/types';
import {
  getGeoLocationConfig,
  postGeoTracking,
  putGeoAuthorization,
} from '@dispatch/shared/services';
import { AxiosResponse } from 'axios';
import { useMutation, useQuery } from 'react-query';
import React from 'react';

export const usePostGeoTracking = (
  responseFn:
    | ((response: AxiosResponse<void, unknown> | undefined) => Promise<void>)
    | undefined = undefined
) => {
  const { mutate, error, status } = useMutation(
    'geo-tracking',
    (data: { geoTracking: GeoTracking; appVersion: string }) =>
      postGeoTracking(data),
    {
      onSettled: (data, err, vars, context) => responseFn?.(data),
    }
  );

  return {
    postGeoTracking: mutate,
    error,
    status,
  };
};

export const usePutGeoAuthorization = (
  responseFn:
    | ((response: AxiosResponse<void, unknown> | undefined) => Promise<void>)
    | undefined = undefined
) => {
  const { mutate, error, status } = useMutation(
    'geo-authorization',
    (data: { resourceId: string; geoAuthorization: GeoAuthorization }) =>
      putGeoAuthorization(data),
    {
      onSettled: (data, err, vars, context) => responseFn?.(data),
    }
  );

  return {
    putGeoAuthorization: mutate,
    error,
    status,
  };
};

export const useGetGeoLocationConfig = (tenantId: string) => {
  const { data } = useQuery(['geoLocation-config', tenantId], () =>
    getGeoLocationConfig(tenantId)
  );

  return {
    geoLocationConfig: data?.data,
  };
};
